import "./scss/styles.scss";
// import * as componentScss from "./components/**/*.scss";
// console.debug(componentScss)
import "./js/app.js";
